import { render, staticRenderFns } from "./secondhand_archived.vue?vue&type=template&id=01374f68&"
import script from "./secondhand_archived.vue?vue&type=script&lang=js&"
export * from "./secondhand_archived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports